export default {
  views: {
    invalidUrl: 'URL이 유효하지 않습니다.',
    successToResetPassword: '비밀번호가 성공적으로 재설정되었습니다.',
    resetPassword: '비밀번호 재설정',
    send: '전송',
    resetError:
      '비밀번호 재설정 링크가 만료되었거나 이미 비밀번호가 재설정되었습니다.',
    passwordRules: {
      title: '참고: 비밀번호 규칙',
      tips1: '영문자와 숫자를 조합하여 8자 이상으로 만들어 주세요.'
    },
    enrollOTP: {
      title: '2단계 인증 등록',
      code: '인증 코드',
      verify: '인증'
    }
  }
};
